<template>
    <v-container>
        <v-row>
            <v-col
                v-for="(e, i) in array"
                :key="i"
                :cols="cols"
                class="soli-round"
            >
                <v-skeleton-loader
                    :type="type"
                    class="soli-round"
                ></v-skeleton-loader
            ></v-col> </v-row
    ></v-container>
</template>

<script>
export default {
    props: {
        length: {
            type: Number,
            default: 1,
        },
        cols: {
            type: Number,
            default: 12,
        },
        type: {
            type: String,
            default: "card",
        },
    },
    computed: {
        array() {
            let array = [];
            array.length = this.length;
            return array;
        },
    },
};
</script>
